import React from 'react';

import { OrdCreate, OrdEdit, OrdShow } from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';

import { QueuesForm } from './QueuesForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { QueueCreate } from '@ragu-components/ord-types';

const QueuesList = React.lazy(async () => import('./QueuesList'));

export const queuesResource: OrdResourceProps = {
  key: Resources.queues,
  name: Resources.queues,
  list: <QueuesList />,
  edit: (
    <OrdEdit>
      <QueuesForm />
    </OrdEdit>
  ),
  create: (
    <OrdCreate>
      <QueuesForm />
    </OrdCreate>
  ),
  show: (
    <OrdShow>
      <QueuesForm />
    </OrdShow>
  ),
  options: {},
  recordRepresentation: (queue: QueueCreate): string => queue.name,
};
